import React, { useState } from "react";
import CountrySelect from "../../common/form/CountrySelect";
import InputField from "./../../common/form/InputField";
import { toast } from "react-toastify";
import { verfiyEmail } from '../../../service/AuthService'
import TermsAndCondition from "../../suspense/TermsAndCondition";

const PersonalInfo = ({ handleImageUpload, values , otpCheck,setOtpCheck}) => {

  const [open, setOpen] = useState(false);

  const email = values.Email

  const emailVerify = async () => {
    console.log('Email:', email);

    try {
      const data = await verfiyEmail({ email });
      // onFormChange("otp"); 
      if(data.header.code===600){
        toast.success("Please check your email for verification code");
        setOpen(true);
        setOtpCheck(true);
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    }
  };


  return (
    <>
      <div>
        <h1 className="text-md font-semibold ">PERSONAL INFO</h1>
        <div className="mt-5 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">

          <div className="sm:col-span-2">
            {/* <InputField type={"email"} label={"Email"} name={"Email"} required
             value={email}
             onChange={handleEmailChange}
             /> */}
         
            <InputField
              type="email"
              label="Email"
              name="Email"
              required
             
            />
            <div>
              <p
                className="text-blue-600 float-right font-semibold underline cursor-pointer focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-3 py-2 me-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700"
                onClick={emailVerify}
              >
                Verify Email
              </p>
            </div>
          </div>


          <div className="sm:col-span-2">
            <InputField
              type={"password"}
              label={"Password"}
              name={"Password"}
              required
            />
          </div>

          <div className="sm:col-span-2">
            <InputField type={"text"} label={"Name"} name={"Name"} required />
          </div>

          <div className="sm:col-span-2">
            <CountrySelect />
          </div>

          <div className="sm:col-span-2">
            <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white" for="multiple_files">  Profile Picture <span className="text-red-500">*</span></label>
            <input className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400" id="multiple_files" type="file" accept="image/jpeg, image/png, image/gif, image/jpg, image/gif" onChange={handleImageUpload} />
            <p class="mt-1 text-sm text-gray-500 dark:text-gray-300" id="file_input_help"> PNG, JPG, JPEG.</p>
          </div>

          <div className="sm:col-span-full">
            <InputField
              type={"text"}
              label={"Biography"}
              name={"ShortBio"}
              inputType={"textarea"}
              rows={3}
            />
          </div>
        </div>
      </div>
      <TermsAndCondition open={open} setOpen={setOpen} setOtpCheck={setOtpCheck} otpCheck={otpCheck} email={email} />
    </>
  );
};

export default PersonalInfo;
